import { c as _c } from "react/compiler-runtime";
import { styled } from '@precis-digital/kurama/utils';
import { type ReactElement, type ReactNode } from 'react';
type MarkdownCodeVariant = 'compact' | 'standard';
interface MarkdownCodeProps {
  node?: unknown;
  inline?: boolean;
  className?: string;
  children?: ReactNode;
  variant?: MarkdownCodeVariant;
}
interface MarkdownPreProps {
  node?: unknown;
  children?: ReactNode;
  variant?: MarkdownCodeVariant;
}
export const MarkdownCode = t0 => {
  const $ = _c(15);
  let children;
  let className;
  let inline;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      node: _node,
      inline: t2,
      className: t3,
      children: t4,
      variant: t5,
      ...t6
    } = t0;
    inline = t2;
    className = t3;
    children = t4;
    t1 = t5;
    props = t6;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = inline;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    inline = $[3];
    props = $[4];
    t1 = $[5];
  }
  const variant = t1 === undefined ? "standard" : t1;
  if (inline === true) {
    let t2;
    if ($[6] !== children || $[7] !== className || $[8] !== props || $[9] !== variant) {
      t2 = <StyledInlineCode className={className} variant={variant} {...props}>{children}</StyledInlineCode>;
      $[6] = children;
      $[7] = className;
      $[8] = props;
      $[9] = variant;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    return t2;
  }
  let t2;
  if ($[11] !== children || $[12] !== className || $[13] !== props) {
    t2 = <code className={className} {...props}>{children}</code>;
    $[11] = children;
    $[12] = className;
    $[13] = props;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};
export const MarkdownPre = t0 => {
  const $ = _c(8);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      node: _node,
      children: t2,
      variant: t3,
      ...t4
    } = t0;
    children = t2;
    t1 = t3;
    props = t4;
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "standard" : t1;
  let t2;
  if ($[4] !== children || $[5] !== props || $[6] !== variant) {
    t2 = <StyledPre variant={variant} {...props}>{children}</StyledPre>;
    $[4] = children;
    $[5] = props;
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const StyledInlineCode = styled('code', {
  shouldForwardProp: prop => prop !== 'variant'
})<{
  variant: MarkdownCodeVariant;
}>(({
  theme,
  variant
}) => {
  const isCompact = variant === 'compact';
  return {
    backgroundColor: theme.tokens.background.tonal.soft.default,
    color: theme.tokens.foreground.main.primary,
    borderRadius: isCompact ? '12px' : theme.borderRadius.medium,
    padding: isCompact ? `2px ${theme.spacing(0)}` : `${theme.spacing(0)} ${theme.spacing(1)}`
  };
});
const StyledPre = styled('pre', {
  shouldForwardProp: prop => prop !== 'variant'
})<{
  variant: MarkdownCodeVariant;
}>(({
  theme,
  variant
}) => {
  const isCompact = variant === 'compact';
  return {
    backgroundColor: theme.tokens.background.tonal.soft.default,
    color: theme.tokens.foreground.main.primary,
    borderRadius: isCompact ? '12px' : theme.borderRadius.medium,
    padding: isCompact ? `2px ${theme.spacing(0)}` : `${theme.spacing(0)} ${theme.spacing(1)}`,
    overflowX: 'auto',
    marginBlockStart: 0,
    marginBlockEnd: theme.spacing(2),
    '&:last-child': {
      marginBlockEnd: 0
    }
  };
});